module.exports = __webpack_public_path__ + "img/production-active.926b27a9.svg";